module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("Curse of the Jackal")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#about-the-author"
    }
  }, [_vm._v("About the Author")])]), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#dedication"
    }
  }, [_vm._v("Dedication")])]), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#copyright-information"
    }
  }, [_vm._v("Copyright Information ©")])]), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#chapter-1-band-of-seekers"
    }
  }, [_vm._v("Chapter 1: Band of Seekers")])]), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#chapter-2-the-fisherman"
    }
  }, [_vm._v("Chapter 2: The Fisherman")])]), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch006#chapter-3-sorcerers-island"
    }
  }, [_vm._v("Chapter 3: Sorcerer’s Island")])]), _c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#chapter-4-lost-warrior",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4: Lost Warrior")])]), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#chapter-5-the-jackal",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5: The Jackal")])]), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#chapter-6-birth-of-legend",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6: Birth of Legend")])]), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#chapter-7-priscas-gift",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7: Prisca’s Gift")])]), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#chapter-8-elgin-the-destroyer",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8: Elgin the Destroyer")])]), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#chapter-9-midnight-sermons",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9: Midnight Sermons")])]), _c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#chapter-10-fog-of-despair",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10: Fog of Despair")])]), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#chapter-11-rocks-ledge",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11: Rock’s Ledge")])]), _c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#chapter-12-blood-and-fire",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12: Blood and Fire")])]), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#chapter-13-demon-slayer",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13: Demon Slayer")])]), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#chapter-14-coral-valley",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14: Coral Valley")])]), _c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch018#chapter-15-mountain-beyond-thoughts",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15: Mountain Beyond Thoughts")])]), _c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch019#chapter-16-battle-of-gidwar-trail",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16: Battle of Gidwar Trail")])]), _c('li', {
    attrs: {
      "id": "toc-li-20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch020#chapter-17-king-of-kings",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 17: King of Kings")])]), _c('li', {
    attrs: {
      "id": "toc-li-21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch021#chapter-18-the-jewel-of-corletus",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 18: The Jewel of Corletus")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41e49fa1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0